import gql from 'graphql-tag';

import { FRAGMENT_BRAND_VOICE } from 'src/graphql/brandVoices';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query CustomerBrandVoices($id: ID!) {
    customer(id: $id) {
      id
      brandVoices {
        ...BrandVoice
      }
    }
  }
  ${FRAGMENT_BRAND_VOICE}
`;

export const queryCustomerBrandVoices = (id) => {
  return executeGqlQuery({
    query: QUERY,
    variables: { id },
  }).then(({ data }) => getSingleProp(data));
};
